const SpanSuccess = ({text}) => {
    return (
        <span className="inline-block rounded-[12px] h-6 lg:w-[68px] w-16 lg:text-base text-[15px] bg-[#3BAE4D] text-white text-center">
            {text}
        </span>
    );
};

export default SpanSuccess;